import React from "react";
import { useTranslation } from "react-i18next";
import { ButtonBase } from "../../../common/components/form";
import WizardButtons from "./WizardButtons.jsx";

export default function BackNext(props) {
    const { t } = useTranslation();

    const WBCN = ["padding-bottom-20"];
    props["wizard-button-class-name"] && WBCN.push(props["wizard-button-class-name"]);

    return (
        <WizardButtons className={WBCN.join(" ") || null}>
            {props.save && (
                <ButtonBase invert onClick={props.save} disabled={!props.allowNext}>
                    {t("Save")}
                </ButtonBase>
            )}

            {props.generate !== undefined && props.generate !== null && (
                <ButtonBase
                    invert
                    onClick={() => {
                        props.generate();
                        props.setShowCustom && props.setShowCustom(false);
                    }}
                    disabled={!props.generate}
                >
                    {t("Generate")}
                </ButtonBase>
            )}

            {props.back && (
                <ButtonBase solid onClick={props.back}>
                    {t("Back")}
                </ButtonBase>
            )}

            {props.cancel && (
                <ButtonBase solid onClick={props.cancel}>
                    {t("Cancel")}
                </ButtonBase>
            )}

            {props.next !== undefined && props.next !== null && (
                <ButtonBase solid onClick={props.next ? props.next : null} disabled={!props.next}>
                    {t("Next")}
                </ButtonBase>
            )}
        </WizardButtons>
    );
}
